import { Mail } from "lucide-react";
import { Link } from "react-router";
import { useSession } from "@/shared/auth/session";
import { ROUTES } from "@/shared/constants/routes";
import { Button } from "@/shared/ui/button";
import { Icon } from "@/shared/ui/icon";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/ui/tooltip";
import { pluralize } from "@/shared/utils/labels";

/** Non-intrusive: an envelope with a count in the top bar, only while invitations to other organisations wait. */
export function InviteIndicator() {
  const { pendingInvites } = useSession();
  if (pendingInvites.length === 0) return null;
  const label = `${pluralize(pendingInvites.length, "invitation")} waiting`;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button asChild variant="ghost" size="sm" className="relative gap-1.5">
          <Link to={ROUTES.onboardingInvitations} aria-label={label}>
            <Icon icon={Mail} size={16} />
            <span className="inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-accent px-1 text-caption font-semibold text-on-accent">
              {pendingInvites.length}
            </span>
          </Link>
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
